export type LeaveGuard = (proceed: () => void) => void;

let current: LeaveGuard | null = null;

export function registerLeaveGuard(guard: LeaveGuard | null): () => void {
  current = guard;
  return () => {
    if (current === guard) current = null;
  };
}

export function leaveGuarded(proceed: () => void): void {
  if (current) current(proceed);
  else proceed();
}
